import React, { useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useParams } from 'react-router-dom';
const { GeoLocation, Zmanim } = require('@hebcal/core');

const Davening = () => {
  const { currentTab } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState();
  const [zmanim, setZmanim] = useState();

  const tabs = ['', 'zmanim'];

  useEffect(() => {
    setActiveTabIndex(
      !currentTab ? 0 : tabs.findIndex((el) => el === currentTab)
    );
    const latitude = 38.659448;
    const longitude = -90.3478282;
    const tzid = 'America/Chicago';
    // const friday = new Date(2023, 8, 8);
    const gloc = new GeoLocation(null, latitude, longitude, 0, tzid);
    setZmanim(new Zmanim(gloc, new Date(), true));
    // const candleLighting = zmanim.sunsetOffset(-18, true);
    // const timeStr = Zmanim.formatISOWithTimeZone(tzid, candleLighting);
  }, []);

  const openAnnouncement = () => {
    fetch('/api/announcement')
      .then((response) => response.json())
      .then((payload) => {
        const url = payload?.weekly_announcement?.url;
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
      });
  };

  const handleTabChange = (newTabIndex) => {
    setActiveTabIndex(newTabIndex);
    if (newTabIndex === 0) {
      window.history.replaceState(null, null, '/davening');
    } else {
      window.history.replaceState(null, null, `/davening/${tabs[newTabIndex]}`);
    }
  };

  return (
    <>
      <div className='page-header text-center d-flex container-fluid justify-content-center align-items-center'>
        <h1>Davening</h1>
      </div>
      <TabView
        className='mt-1 nav-ribbon'
        activeIndex={activeTabIndex}
        onTabChange={(e) => handleTabChange(e.index)}
        scrollable
      >
        <TabPanel header='Schedule'>
          <Container className='justify-content-center'>
            <Row>
              <Col className='text-center'>
                <h2>
                  <b>Shabbat</b>
                </h2>
                {/* <Row> */}
                {/* <Col> */}
                <h4>
                  <u>Erev Shabbat</u>
                </h4>
                <span>
                  <b>Kabbalat Shabbat (winter):</b> candlelighting*
                </span>{' '}
                <br />
                <span>
                  <b>Kabbalat Shabbat (summer):</b> 7:00 PM
                </span>{' '}
                <br /> <br />
                <h4>
                  <u>Shabbat Day</u>
                </h4>
                <h6 className='text-muted mb-1'>
                  <em>Shacharit</em>
                </h6>
                <span>
                  <b>Hashkama:</b> 7:30 AM
                </span>{' '}
                <br />
                <span>
                  <b>Main Minyan:</b> 9:00 AM
                </span>{' '}
                <br />
                <span>
                  <b>Teen Minyan:</b> 9:30 AM
                </span>{' '}
                <br />
                <span>
                  <b>Shabbat Youth Groups:</b> 9:30
                  AM
                </span>{' '}
                <br /> <br />
                {/* </Col> */}
                {/* <Col> */}
                <h6 className='text-muted mb-1'>
                  <em>Mincha/Maariv</em>
                </h6>
                <span>35 minutes before sunset</span>
                {/* </Col> */}
                {/* </Row> */}
              </Col>
              <Col className='text-center'>
                <h2>
                  <b>Weekdays</b>
                </h2>
                <h4>
                  <u>Shacharit</u>
                </h4>
                <span>
                  <b>Sundays & Legal Holidays*</b> 8:00 AM
                </span>{' '}
                <br />
                <span>
                  <b>Mondays & Thursdays:</b> 6:30 AM
                </span>{' '}
                <br />
                <span>
                  <b>Tuesdays, Wednesdays, and Fridays:</b> 6:40 AM
                </span>{' '}
                <br />
                <br />
                {/* </Col> */}
                {/* <Col> */}
                <h4>
                  <u>Mincha/Maariv</u>
                </h4>
                <span>20 minutes before sunset</span>
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col className='text-center'>
                <h4>
                  *for more details see this week's{' '}
                  <a
                    style={{ cursor: 'pointer', textDecoration: 'underline', color: '#006494' }}
                    onClick={openAnnouncement}
                  >
                     announcements.
                  </a>
                </h4>
              </Col>
            </Row>
          </Container>
        </TabPanel>
        <TabPanel header='Zmanim'>
          <Container>
            {zmanim && (
              <>
                <h3 className='fw-bold'>
                  Important Zmanim for{' '}
                  {new Date().toLocaleDateString('en-US', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                  :
                </h3>
                <ul className='mt-3'>
                  <li>
                    Alot:{' '}
                    {zmanim
                      .alotHaShachar()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Sunrise:{' '}
                    {zmanim
                      .sunrise()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Latest Sh'ma:{' '}
                    {zmanim
                      .sofZmanShma()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Chatzot:{' '}
                    {zmanim
                      .chatzot()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Mincha Gedola:{' '}
                    {zmanim
                      .minchaGedolaMGA()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Plag HaMincha:{' '}
                    {zmanim
                      .plagHaMincha()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Sunset:{' '}
                    {zmanim
                      .sunset()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                  <li>
                    Tzeit:{' '}
                    {zmanim
                      .tzeit()
                      .toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit'
                      })}
                  </li>
                </ul>
              </>
            )}
          </Container>
        </TabPanel>
      </TabView>
    </>
  );
};

export default Davening;
